<template> 
  <div  class="common-layout">
    <router-view/>
  </div>
</template>

<script>

const debounce = (fn, delay) => {
  let tid = null;
  return function () {
    const ctx = self;
    let args = arguments;
    tid && clearTimeout(tid);
    tid = setTimeout(() => {
      fn.apply(ctx, args);
    }, delay);
  };
}

const _ = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}

export default {
  name: 'App', 
}

</script>

<style>
  
.common-layout {
    padding: 0px;
    margin: 0px;
    height: 100%;    
}
</style>
